import { render } from "./ReviewAndSubmit.vue?vue&type=template&id=3d00368a&scoped=true"
import script from "./ReviewAndSubmit.vue?vue&type=script&lang=js"
export * from "./ReviewAndSubmit.vue?vue&type=script&lang=js"

import "./ReviewAndSubmit.vue?vue&type=style&index=0&id=3d00368a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d00368a"]])

export default __exports__